import { render, staticRenderFns } from "./ButtonAssignBuyer.vue?vue&type=template&id=ca784238&"
import script from "./ButtonAssignBuyer.vue?vue&type=script&lang=ts&"
export * from "./ButtonAssignBuyer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports